<script lang="ts">
  import { browser } from '$app/environment';
  import { onMount } from 'svelte';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import { accessibilityPreferences } from '$lib/stores/accessibility';
  import type { AccessibilityPreferences } from '$lib/stores/accessibility';

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));

  accessibilityPreferences.subscribe((state: AccessibilityPreferences) => {
    if (!browser) {
      return;
    }

    document.documentElement.setAttribute('reduce-motion', String(state.reduceMotion));
    document.documentElement.setAttribute('reduce-color', String(state.reduceColor));
  });

  onMount(() => {
    // With the rebrand, we are removing the accessibility preferences modal.
    // We will instead delegate control of a11y preferences to users' system settings.
    if (brandReskinEnabled) {
      accessibilityPreferences.setReduceColor(
        window.matchMedia('(prefers-contrast: more)').matches
      );
      accessibilityPreferences.setReduceMotion(
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }
  });
</script>
